import React, { useState } from "react";

// Alle möglichen Felder mit Labels
const FELDER = [
  { key: "absender",        label: "Absender",          icon: "👤" },
  { key: "datum",           label: "Datum",             icon: "📅" },
  { key: "prefix",          label: "Prefix / Objekt",   icon: "🏠" },
  { key: "rechnungsnummer", label: "Rechnungsnummer",   icon: "🔢" },
  { key: "schema",          label: "Dokumenttyp",       icon: "📋" },
  { key: "mandant",         label: "Mandant",           icon: "👥" },
  { key: "bank",            label: "Bank",              icon: "🏦" },
  { key: "betrag",          label: "Betrag",            icon: "💶" },
  { key: "leistungszeitraum", label: "Leistungszeitraum", icon: "📆" },
];

export default function FehlerMarkierer({ dateiname, onFehlerBestaetigt }) {
  const [aktiveFehler, setAktiveFehler] = useState({});
  // { "absender": { current_value: "###", correct_value: "", aktiv: true } }

  const toggleFeld = (key) => {
    setAktiveFehler((prev) => {
      if (prev[key]) {
        const aktualisiert = { ...prev };
        delete aktualisiert[key];
        return aktualisiert;
      }
      return {
        ...prev,
        [key]: { current_value: "", correct_value: "", aktiv: true },
      };
    });
  };

  const setzeKorrekturwert = (key, wert) => {
    setAktiveFehler((prev) => ({
      ...prev,
      [key]: { ...prev[key], correct_value: wert },
    }));
  };

  const setzeAktuellenWert = (key, wert) => {
    setAktiveFehler((prev) => ({
      ...prev,
      [key]: { ...prev[key], current_value: wert },
    }));
  };

  const hatFehler = Object.keys(aktiveFehler).length > 0;
  const alleVollstaendig = hatFehler && Object.values(aktiveFehler).every(
    (f) => f.correct_value.trim().length > 0
  );

  // Aus Dateiname aktuelle Werte ableiten
  const parseAktuell = (key) => {
    if (!dateiname) return "";
    const parts = dateiname.replace(".pdf", "").split(" - ");
    switch (key) {
      case "prefix":         return parts[0] || "";
      case "datum":          return parts[1] || "";
      case "absender":       return parts[2] || "";
      case "schema":         return parts[3]?.split(" ")[0] || "";
      case "rechnungsnummer": return parts[3]?.split(" ").slice(1).join(" ") || "";
      default:               return "";
    }
  };

  const bestaetigen = () => {
    if (!alleVollstaendig) return;
    const fehlerliste = Object.entries(aktiveFehler).map(([field, v]) => ({
      field,
      current_value: v.current_value || parseAktuell(field),
      correct_value: v.correct_value,
    }));
    onFehlerBestaetigt(fehlerliste);
  };

  return (
    <div className="fehler-markierer">
      <h3 className="fehler-titel">Was ist falsch?</h3>
      {dateiname && (
        <div className="aktueller-dateiname">
          <span className="dateiname-label">Aktuell:</span>
          <code>{dateiname}</code>
        </div>
      )}

      <div className="felder-grid">
        {FELDER.map((feld) => {
          const istAktiv = !!aktiveFehler[feld.key];
          const fehlerInfo = aktiveFehler[feld.key];
          return (
            <div
              key={feld.key}
              className={`feld-karte ${istAktiv ? "aktiv" : ""}`}
            >
              <div
                className="feld-header"
                onClick={() => toggleFeld(feld.key)}
              >
                <span className="feld-icon">{feld.icon}</span>
                <span className="feld-label">{feld.label}</span>
                <span className={`feld-markierung ${istAktiv ? "an" : ""}`}>
                  {istAktiv ? "✗ Falsch" : "+ Markieren"}
                </span>
              </div>

              {istAktiv && (
                <div className="feld-korrektur">
                  <div className="korrektur-zeile">
                    <label>Aktueller falscher Wert:</label>
                    <input
                      type="text"
                      placeholder={parseAktuell(feld.key) || `z.B. ###`}
                      value={fehlerInfo.current_value}
                      onChange={(e) => setzeAktuellenWert(feld.key, e.target.value)}
                    />
                  </div>
                  <div className="korrektur-zeile">
                    <label>Richtiger Wert: *</label>
                    <input
                      type="text"
                      placeholder={`Richtiger ${feld.label}...`}
                      value={fehlerInfo.correct_value}
                      onChange={(e) => setzeKorrekturwert(feld.key, e.target.value)}
                      autoFocus
                    />
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="fehler-footer">
        {hatFehler && !alleVollstaendig && (
          <span className="fehler-hinweis">
            Bitte alle markierten Felder mit dem richtigen Wert ausfüllen.
          </span>
        )}
        <button
          className={`lern-btn ${alleVollstaendig ? "bereit" : "deaktiviert"}`}
          onClick={bestaetigen}
          disabled={!alleVollstaendig}
        >
          🤖 KI lernen lassen
        </button>
      </div>
    </div>
  );
}
